const { isUndefined } = require('lodash');
const { getBuyerAssumedLanguage } = require('@fiverr-private/localization');
const { highlightTypes, excludedSellerSpeaksLanguage } = require('../../constants');

/**
 * @type {import('../../../server/highlights/index').computeHighlights}
 */
const computeHighlights = ({
    highlightsToShow = 1,
    sellerData,
    collaborateData,
    matchingIndustriesData,
    locale,
    browserLanguage,
    countryCode,
    hideInactiveSellerHighlight = false,
    hideSellerOnVacationHighlight = false,
    hideProVerifiedHighlight = false,
    hideSellerSpeaksHighlight = false,
}) => {
    const highlights = [];

    highlights.push(getInactiveSellerHighlight(hideInactiveSellerHighlight, sellerData));
    highlights.push(getSellerOnVacationHighlight(hideSellerOnVacationHighlight, sellerData));
    highlights.push(getProVerifiedHighlight(hideProVerifiedHighlight, sellerData));
    highlights.push(getCollaboratedHighlight(sellerData, collaborateData));
    highlights.push(getMatchingIndustriesHighlight(sellerData, matchingIndustriesData));
    highlights.push(getLoyaltyHighlight(sellerData));
    highlights.push(getLanguageHighlight(hideSellerSpeaksHighlight, sellerData, locale, browserLanguage, countryCode));

    highlights.push(getResponsiveHighlight(sellerData));

    const filteredHighlights = highlights.filter((element) => !isUndefined(element));

    if (filteredHighlights.length > highlightsToShow) {
        return filteredHighlights.slice(0, highlightsToShow);
    }

    return filteredHighlights;
};

const getInactiveSellerHighlight = (hide, sellerData) => {
    if (!hide && sellerData?.isActive === false) {
        return {
            type: highlightTypes.inactiveSeller,
        };
    }
};

const getSellerOnVacationHighlight = (hide, sellerData) => {
    if (!hide && sellerData?.vacation?.endsAt > Date.now() / 1000) {
        return {
            type: highlightTypes.sellerOnVacation,
            additionalData: {
                endsAt: sellerData?.vacation?.endsAt,
            },
        };
    }
};

const getProVerifiedHighlight = (hide, sellerData) => {
    if (!hide && sellerData?.isPro) {
        return {
            type: highlightTypes.proVerified,
        };
    }
};

const getCollaboratedHighlight = (sellerData, collaborateData) => {
    const sellerId = sellerData?.user?.id;
    if (sellerId && collaborateData && collaborateData[sellerId]) {
        return {
            type: highlightTypes.collaborate,
            additionalData: {
                collaborateData: collaborateData[sellerId],
            },
        };
    }
};

const getMatchingIndustriesHighlight = (sellerData, matchingIndustriesData) => {
    const sellerId = sellerData?.user?.id;
    if (
        sellerId &&
        matchingIndustriesData?.matching_industries &&
        matchingIndustriesData?.matching_industries[sellerId]
    ) {
        return {
            type: highlightTypes.matchingIndustries,
            additionalData: {
                title: matchingIndustriesData?.matching_industries[sellerId]?.title,
                buyerCount: matchingIndustriesData?.matching_industries[sellerId]?.buyer_count,
            },
        };
    }
};

const getLoyaltyHighlight = (sellerData) => {
    if (sellerData?.hasLoyaltyScores) {
        return {
            type: highlightTypes.loyalty,
        };
    }
};

const getLanguageHighlight = (hide, sellerData, locale, browserLanguage, countryCode) => {
    const buyerAssumedLanguage = getBuyerAssumedLanguage({ locale, browserLanguage, countryCode }).toLowerCase();
    const buyerLanguageIsExcluded = excludedSellerSpeaksLanguage.includes(buyerAssumedLanguage);
    const sellerLanguages = sellerData?.user?.languages || [];
    let res;
    if (!hide && !buyerLanguageIsExcluded) {
        sellerLanguages.forEach((language) => {
            if (language?.code?.toLowerCase() === buyerAssumedLanguage) {
                res = {
                    type: highlightTypes.language,
                    additionalData: {
                        language: buyerAssumedLanguage,
                    },
                };
            }
        });
    }
    return res;
};

const getResponsiveHighlight = (sellerData) => {
    if (sellerData?.isHighlyResponsive) {
        return {
            type: highlightTypes.responsive,
        };
    }
};

module.exports = computeHighlights;
